{
    "ChartprovideroptionsHighcharts": "Hoge hitlijsten",
    "ChartprovideroptionsAmcharts": "AM-kaarten",
    "NAME": "ChartProviderOptions"
}